import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from '../../environment/environment';
import { TagModel } from '../models/tag.model';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  constructor(private http: HttpClient) {}

  getAllTags(): Observable<TagModel[]> {
    const formData = new FormData();
    formData.append('mode', 'getAllTags');

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: TagModel[];
      }>(environment.authority_short + 'tag.php', formData)
      .pipe(
        map(response =>
          response.data?.map(tag => this.parseBackendTagModel(tag))
        ),
        catchError(() => {
          return throwError(() => new Error('Failed to fetch tags'));
        })
      );
  }

  parseBackendTagModel(tag: TagModel): TagModel {
    return {
      id: tag.id,
      name: tag.name,
    };
  }
}
